/*
 * DER VISUELLE EDITOR BEARBEITET NUR DEN KOERPER — DER REST DER DATEI BLEIBT STEHEN
 * (Sahori Seefoo, 25.09. und 29.09.2026: „Editor strips <head>/<style> from HTML on save").
 *
 * TinyMCE (ohne das in Version 6 entfernte fullpage-Plugin) gibt bei `onEditorChange` nur den
 * Inhalt von <body> zurueck. FilePreview speicherte diesen Wert als ganze Datei: weg waren
 * <!DOCTYPE>, <head> mit charset und dem ganzen <style>-Block — die Seite stand ungestaltet da,
 * ihre Textaenderung selbst war richtig. Jetzt wird die Datei an <body ...> und </body> geteilt;
 * nur der Teil dazwischen geht in den Editor, und jede Aenderung wird wieder in den
 * unveraenderten Rahmen gesetzt. Die <style>-Bloecke des Kopfes wirken als `content_style` im
 * Editor, damit die Seite beim Bearbeiten so aussieht wie in der Vorschau.
 * Eine Datei ohne <body> (ein Schnipsel) wird unveraendert ganz bearbeitet — wie bisher.
 */
export type HtmlTeile = { vor: string; inhalt: string; nach: string; stile: string };

export function zerlegeHtmlDokument(html: string): HtmlTeile {
  const auf = /<body\b[^>]*>/i.exec(html);
  if (!auf) return { vor: '', inhalt: html, nach: '', stile: '' };
  const start = auf.index + auf[0].length;
  const zuIndex = html.toLowerCase().lastIndexOf('</body');
  const ende = zuIndex >= start ? zuIndex : html.length;
  const vor = html.slice(0, start);
  const stile = [...vor.matchAll(/<style\b[^>]*>([\s\S]*?)<\/style\s*>/gi)].map(m => m[1]).join('\n');
  return { vor, inhalt: html.slice(start, ende), nach: html.slice(ende), stile };
}

export function setzeHtmlDokument(teile: Pick<HtmlTeile, 'vor' | 'nach'>, inhalt: string): string {
  return teile.vor + inhalt + teile.nach;
}
